import HubBuyTherapyPage from './HubBuyTherapyPage'

export default HubBuyTherapyPage
